/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { cloneDeep, isEmpty } from 'lodash';

// Components
import ConditionRule from 'shared/ui/components/form-components/targeting/ConditionRule.vue';

const __vue_script__ = {
    name: 'ConditionsEditor',

    components: { ConditionRule },

    props: {
        fields: {
            type: Array,
            required: true
        },

        value: {
            type: Array,
            default: () => [[{}]]
        },

        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            valueClone: []
        };
    },

    computed: {
        /** @returns {array} */
        innerValue() {
            const availableNames = this.fields.map(f => f.name || f._init);
            return this.valueClone.filter(r => !isEmpty(r.filter(p => {
                return !isEmpty(p) && availableNames.includes(p.name) || p._init;
            })));
        },

        /** @returns {boolean} */
        hasData() {
            return Boolean(this.innerValue.length);
        },

        /** @returns {boolean} */
        canAddRule() {
            return !this.readOnly && this.valueClone.every(r => r.every(p => p.hasOwnProperty('value')));
        }
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                this.valueClone = cloneDeep(this.value);
            }
        },

        fields: {
            deep: true,
            handler() {
                const availableNames = this.fields.map(f => f.name || f._init);
                for (const [i, rule] of this.valueClone.entries()) {
                    for (const [j, predicate] of rule.entries()) {
                        if (!availableNames.includes(predicate.name)) {
                            this.valueClone[i].splice(j, 1);
                        }
                    }
                }
                this.emit();
            }
        }
    },

    methods: {
        /**
         * Adds a new set of rules (will eval as OR)
         */
        addRule() {
            if (!this.canAddRule) {
                return;
            }

            this.$set(this.valueClone, this.valueClone.length, [{ _init: true }]);
            this.emit();
        },

        /**
         * Since `this.value` is an array it won't trigger under the watcher,
         * hence we manually listen to the `input` events to emit what's proper
         * with this handler.
         */
        checkStatus() {
            this.emit();
        },

        /**
         * Emits the value if there is valid data (which is filtered and cleansed
         * from empty values). In case the compnent doesn't hold data we emit
         * a special event called `empty`.
         */
        emit() {
            if (this.hasData) {
                this.$emit('input', this.innerValue);
            } else {
                this.$emit('empty');
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "conditions-editor" }, [
    _c("div", { staticClass: "info-legend" }, [
      _c("div", { staticClass: "legend" }, [
        _vm._v(_vm._s(_vm.$t("targeting.conditions_editor.visible_to"))),
      ]),
    ]),
    _c("div", { staticClass: "predicates-editor" }, [
      _c(
        "div",
        { staticClass: "rules" },
        [
          _vm._l(_vm.valueClone, function (rule, index) {
            return [
              _c("condition-rule", {
                attrs: { fields: _vm.fields, "read-only": _vm.readOnly },
                on: { input: _vm.checkStatus },
                model: {
                  value: _vm.valueClone[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.valueClone, index, $$v)
                  },
                  expression: "valueClone[index]",
                },
              }),
              index < _vm.valueClone.length - 1
                ? _c("span", { staticClass: "separator" }, [
                    _vm._v(_vm._s(_vm.$t("base.or"))),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      !_vm.readOnly || !_vm.hasData
        ? _c("div", { staticClass: "editor-actions" }, [
            _c(
              "a",
              {
                staticClass: "add-and-set has-action",
                attrs: { disabled: !_vm.canAddRule },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.addRule.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("targeting.conditions_editor.add_rule")))]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/targeting/ConditionsEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__